const GET_SHOP_NAMES = "GET_SHOP_NAMES";
const GET_SHOP_NAMES_SUCCESS = "GET_SHOP_NAMES_SUCCESS";
const GET_SHOP_NAMES_FAILURE = "GET_SHOP_NAMES_FAILURE";
const CLEAR_GET_SHOP_NAMES = "CLEAR_GET_SHOP_NAMES";
const GetMerchantInfoSymbols = {
  GET_SHOP_NAMES_SUCCESS,
  GET_SHOP_NAMES_FAILURE,
  GET_SHOP_NAMES,
  CLEAR_GET_SHOP_NAMES,
};
export default GetMerchantInfoSymbols;
